var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUsersB(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 16,
    viewBox: "0 0 22 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.07043 14.9769C1.1096 14.8855 1.14877 14.8017 1.18794 14.7179C1.79899 13.385 2.78606 12.2348 4.33718 11.3512C5.70812 10.5743 7.2279 10.3305 8.85735 10.6657C9.67208 10.8409 10.385 11.1379 11.0273 11.5416C11.4504 11.8082 11.8421 12.1205 12.2024 12.4785C12.8997 13.1641 13.4167 13.9105 13.7927 14.7179",
    stroke: "#263859",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5056 10.5137C14.9521 10.5137 15.4065 10.567 15.8687 10.666C17.224 10.9555 18.3129 11.5953 19.2138 12.4788C19.911 13.1644 20.4281 13.9108 20.8041 14.7182C20.8433 14.802 20.8824 14.8934 20.9216 14.9772",
    stroke: "#263859",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9805 3.39176C10.4242 2.04355 9.07681 1.08382 7.53353 1.0762C5.41837 1.06858 3.71841 2.69861 3.70274 4.73235C3.68708 6.75846 5.39487 8.41135 7.50219 8.41896C9.06114 8.42658 10.4242 7.45922 10.9883 6.11102C11.1606 5.69209 11.2625 5.24268 11.2625 4.77043C11.2546 4.28295 11.1606 3.81831 10.9805 3.39176Z",
    stroke: "#263859",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5135 8.41894C16.5504 8.42655 18.266 6.77367 18.2738 4.7704C18.2738 2.75191 16.5817 1.08379 14.5527 1.07617",
    stroke: "#263859",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsersB);
export default __webpack_public_path__ + "static/media/users-b.40bb64e5b6b282e291434d30965d8ee4.svg";
export { ForwardRef as ReactComponent };